import { ConvexClient } from "convex/browser";

export const convex = new ConvexClient(
  import.meta.env.VITE_CONVEX_URL as string
);
